import React, { useMemo, useState } from 'react';
import { emailValidation } from '@sv-support-sdk/utils/src/helpers/validations';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import MessagePlaceholder from '../../ui/Content/Message/MessagePlaceholder';
import Headline from '../../ui/Typography/Headline';
import Input from '../../ui/Controls/Input';
import Button from '../../ui/Controls/Button';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { updateUserName } from '../../../store/actions/chat';
import { selectUserUuid } from '../../../store/selectors/user';
import { $l } from '../../../locales';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { CHAT_EMAIL_REQUEST_INPUT, CHAT_EMAIL_SEND } from '../../../constants/qaAttributes';

const AskEmail = () => {
  const [email, setEmail] = useState('');
  const [blur, setBlur] = useState(false);
  const [loading, setLoading] = useState(false);
  const uuid = useAppSelector(selectUserUuid);

  const emailValid = useMemo(() => emailValidation(email), [email]);

  const dispatch = useAppDispatch();
  const updateEmail = ({ target: { value } }: { target: { value: string } }) => {
    setEmail(value);
  };
  const send = async () => {
    setBlur(true);
    if (!emailValid) return;

    setLoading(true);

    try {
      await dispatch(updateUserName({ name: email, uuid }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <MessagePlaceholder>
      <List gap="16" width="full">
        <Headline type="secondary" fontSize="16">
          {$l('CONTACT_INFO')}
        </Headline>
        <Input
          value={email}
          onChange={updateEmail}
          onBlur={() => setBlur(true)}
          placeholder={$l('ENTER_YOUR_EMAIL')}
          isInvalid={!emailValid && blur}
          {...setQaAttribute(CHAT_EMAIL_REQUEST_INPUT)}
        />
        <Button
          text={$l('SEND')}
          onClick={send}
          disabled={(blur && !emailValid) || loading}
          size="small"
          {...setQaAttribute(CHAT_EMAIL_SEND)}
        />
      </List>
    </MessagePlaceholder>
  );
};

export default AskEmail;
